import React from "react";
import "./App.scss";
import View from "./view/View";
function App() {
  return (
    <div className="App">
      <View />
    </div>
  );
}

export default App;
